import { Tag } from '@vtex/shoreline'
import styled, { css } from 'styled-components'

/* A pílula não deve quebrar em duas linhas em colunas estreitas de tabela;
   labels longos (ex: "Custo abaixo do orçamento") truncam com reticências
   em vez de vazar para a célula vizinha. */
export const StatusTag = styled(Tag)`
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const containerModifier = {
  default: ({ theme }) => css`
    --main-color: ${theme.colors.light};
  `,
  success: ({ theme }) => css`
    --main-color: ${theme.colors.success};
  `,
  success_alert: ({ theme }) => css`
    --main-color: ${theme.colors.successAlert};
  `,
  warning: ({ theme }) => css`
    --main-color: ${theme.colors.warning};
  `,
  danger: ({ theme }) => css`
    --main-color: ${theme.colors.danger};
  `,
  info: ({ theme }) => css`
    --main-color: ${theme.colors.info};
  `
}

/* `informational` e `critical` são os mesmos tons com os nomes que as variantes
   de alerta usam; o mapa de status de retail media fala esse vocabulário. */
const modifierByTemplate = {
  ...containerModifier,
  informational: containerModifier.info,
  critical: containerModifier.danger
}

/* Os estados de pedido do chat caem nos mesmos três tons. Tabela em vez de uma
   comparação por estado: eram dezessete ramos numa função só. */
const modifierByType = {
  ...modifierByTemplate,
  order_placed: containerModifier.success,
  confirmed_order: containerModifier.success,
  waiting_payment: containerModifier.warning,
  waiting_delivery: containerModifier.warning,
  waiting_picking: containerModifier.warning,
  in_picking: containerModifier.warning,
  in_delivery: containerModifier.warning,
  order_delivered: containerModifier.success,
  order_canceled: containerModifier.danger
}

export const Container = styled.div<ContainerStatusStylesProps>`
  ${({ type, template, onlyBullet = false, theme }) => css`
    display: ${onlyBullet ? 'inline-flex' : 'flex'};
    align-items: center;

    line-height: 1;

    color: ${theme.colors.dark};

    ${containerModifier.default({ theme })}

    ${type && modifierByType[type]?.({ theme })}
    ${template && modifierByTemplate[template]?.({ theme })}

    &:before {
      content: '';
      display: inline-flex;
      flex-shrink: 0;

      height: 0.5rem;
      width: 0.5rem;

      margin-right: 0.5em;

      border-radius: 50%;
      background: var(--main-color);
    }
  `}
`
